import moment from 'moment'
import { ServiceTime, ServiceTimeKindType } from '@ancon/wildcat-types'

type Translate = (key: string) => string

/**
 * A short label for when an order is wanted: "Now" for as soon as possible,
 * otherwise e.g. "Today, 12:30", "Tomorrow, 12:30" or "Fri 16 Oct, 12:30"
 */
export default function getServiceTimeLabel(
  serviceTime: ServiceTime | null | undefined,
  t: Translate,
): string {
  if (
    !serviceTime?.time ||
    serviceTime.kind === ServiceTimeKindType.AsSoonAsPossible
  ) {
    return t('orderTimeSwitch.orderNow')
  }

  return moment(serviceTime.time).calendar({
    sameDay: `[${t('today')}], LT`,
    nextDay: `[${t('tomorrow')}], LT`,
    nextWeek: 'ddd D MMM, LT',
    lastDay: 'ddd D MMM, LT',
    lastWeek: 'ddd D MMM, LT',
    sameElse: 'ddd D MMM, LT',
  })
}
